// src/api/tags.ts
import axiosClient from "./axiosClient";

export const tagApi = {
  editTag: (userKey: number, token: string, tagKey: number, languageValues: {english?: string, japanese?: string} ) => {
    return axiosClient.post(`/editTag`, { tagKey, languageValues });
  },

  deleteTag: (tagKey: number, userKey: number, token: string) => {
    return axiosClient.post(`/deleteTag`, { tagKey });
  },

  saveTag: (userKey: number, token: string, languageValues: {english?: string, japanese?: string}, parentKey: number | null ) => {
    return axiosClient.post(`/saveTag`, { languageValues, parentKey });
  },
};
